import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTradingViewSteps: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="trading-view-steps"><path d="M3.75 7.75V16.25M9.25 3.75V12.25M14.75 11.75V20.25M20.25 7.75V16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconTradingViewSteps;
